import type { SyntheticEvent } from 'react';

import { Tab, Tabs } from '@mui/material';

import { CollapseFilter } from '../collapse-filter';

type TabFilterProps<Data> = {
  title: string;
  options: Data[];
  value: string;
  onChange: (value: string) => void;
  getKey: (option: Data) => string;
  getValue: (option: Data) => string;
  getLabel: (option: Data) => string;
};

export function TabFilter<Data>(props: TabFilterProps<Data>) {
  const { title, options, value, onChange, getKey, getValue, getLabel } = props;

  const handleChange = (_event: SyntheticEvent, newValue: string) => {
    onChange(newValue);
  };

  return (
    <CollapseFilter title={title}>
      <Tabs value={value} onChange={handleChange} variant="pill">
        {options.map((option) => (
          <Tab
            key={getKey(option)}
            label={getLabel(option)}
            value={getValue(option)}
            variant="pill"
          />
        ))}
      </Tabs>
    </CollapseFilter>
  );
}
